import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Colors } from '../../../models/enums/colors.enum';
import { HttpService } from '../../../services/http.service';
import { ISubscription } from 'rxjs/Subscription';
import { DragScrollModule } from 'ngx-drag-scroll';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('scroll', { read: ElementRef }) ds: ElementRef;
  @ViewChild('table') table: ElementRef;

  data: any;
  colors = Colors;

  scrollContainer;
  scrollContainerHeight;
  scrollContainerScrollHeight;
  scrollDirectionDown: boolean = true;
  pause: boolean = false;

  fps: number = 15;
  fpsInterval: number;
  startTime: number;
  now: number;
  then: number;
  elapsed: number;

  subscription: ISubscription;
  animating = false;
  animationId: number;

  circleWidth: number;
  openWidth: number;
  changedWidth: number;
  countWidth: number;
  entityWidth: number;
  metricWidth: number;

  viewLoaded: Boolean = false;
  tableLoaded: Boolean = false;

  constructor(private http: HttpService, private cdref: ChangeDetectorRef) {
    this.subscription = this.http.tableData().subscribe(data => {
      this.data = data;
      this.handleView();
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {

    this.scrollContainer = this.ds.nativeElement.querySelector('.drag-scroll-content');
    this.viewLoaded = true;
    this.cdref.detectChanges();
  }

  handleView(){
    if (!this.viewLoaded) return;

    this.scrollContainerHeight = this.scrollContainer.getBoundingClientRect().height;
      this.scrollContainerScrollHeight = this.scrollContainer.scrollHeight;

      //If there is overflow, start scrolling animation
      if(!this.animating && (this.scrollContainerScrollHeight > this.scrollContainerHeight)){
        this.fpsInterval = 1000 / this.fps;
        this.then = Date.now();
        this.startTime = this.then;

        this.animationId = requestAnimationFrame(() => {
            this.animateScroll(1);
        });

        this.cdref.detectChanges();
        this.animating = true;
      }
      //Else if no overflow and animation is running, cancel the animation
      if (this.animating && (this.scrollContainerScrollHeight <= this.scrollContainerHeight)){
        cancelAnimationFrame(this.animationId);
        this.animating = false;
      }

      if (this.table.nativeElement.querySelector('.count-col') != null){
        this.tableLoaded = true;
        this.circleWidth = this.table.nativeElement.querySelector('.circle-col').getBoundingClientRect().width;
        this.openWidth = this.table.nativeElement.querySelector('.open-col').getBoundingClientRect().width;
        this.changedWidth = this.table.nativeElement.querySelector('.changed-col').getBoundingClientRect().width;
        this.countWidth = this.table.nativeElement.querySelector('.count-col').getBoundingClientRect().width;
        this.entityWidth = this.table.nativeElement.querySelector('.entity-col').getBoundingClientRect().width;
        this.metricWidth = this.table.nativeElement.querySelector('.metric-col').getBoundingClientRect().width;
      }
  }

  animateScroll(speed) {
    if (!this.pause) {
      this.now = Date.now();
      this.elapsed = this.now - this.then;

      if (this.elapsed > this.fpsInterval || this.fps == 0) {

        this.then = this.now - (this.elapsed % this.fpsInterval);

        if (this.scrollDirectionDown) {
          this.scrollContainer.scrollTop += speed;
        }
        else {
          this.scrollContainer.scrollTop -= speed;
        }
        if (this.scrollContainer.scrollTop >= Math.abs(Math.floor((this.scrollContainerScrollHeight - this.scrollContainerHeight)))) {
          setTimeout(() => {
            this.scrollDirectionDown = false;
          }, 1000);
        }
        if (this.scrollContainer.scrollTop <= 0) {
          setTimeout(() => {
            this.scrollDirectionDown = true;
          }, 2000);
        }
      }
    }

    requestAnimationFrame(() => {
      this.animateScroll(speed);
    });
  }

  pauseAnimation(){
    this.pause = true;
  }
  restartAnimation(){
    this.pause = false;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/table-column/table/table.component.ts